import { State } from '.'
export default {
  getPaymentsUrl: (state: State) => state.paymentUrl,
  getPaymentStatus: (state: State) => state.status,
  getPaymentSecret: (state: State) => state.secret,
}
